// extracted by mini-css-extract-plugin
module.exports = {"sub-text":"share_buttons__sub-text___NkpL3"};